import queryString from 'query-string';

export default class CurrentPage {
  static hasHash(string) {
    return window.location.hash === `#${string}`;
  }

  static setHash(string) {
    window.location.hash = `#${string}`;
  }

  static isArticle() {
    return typeof(window.ENV?.article?.id) == 'number';
  }

  static isArticlePreview() {
    return queryString.parse(window.location.search)?.preview === 'true';
  }

  static isArticlePaywalled() {
    return window.ENV?.article?.isPaywalled === true;
  }

  static getArticleId() {
    if (this.isArticle()) {
      return window.ENV.article.id;
    } else {
      return -1;
    }
  }

  static getArticleAuthorId() {
    if (this.isArticle()) {
      return window.ENV.article.authorId;
    } else {
      return -1;
    }
  }

  static getArticleConversationHostId() {
    if (this.isArticle()) {
      return window.ENV.article.conversationHostId;
    } else {
      return -1;
    }
  }

  static getArticleUrlSafeTitle() {
    if (this.isArticle()) {
      return window.ENV.article.urlSafeTitle;
    } else {
      return '';
    }
  }

  static getTrackMetricsActionPath() {
    return window.ENV.trackMetricsActionPath;
  }

  static getUserGoalMarkTrackedActionPath() {
    return window.ENV.userGoalMarkTrackedActionPath;
  }

  static hasShareUrl() {
    return typeof(window.ENV?.shareUrl?.id) == 'number';
  }

  static getShareUrl() {
    return window.ENV.shareUrl;
  }

  static isAccessWallIframeLocked() {
    return window.ENV.accessWall?.isUnlocked === false;
  }

  static isAccessWallIframeUnlocked() {
    return window.ENV?.accessWall?.isUnlocked === true;
  }

  static accessWallIframeSrc() {
    return window.ENV.accessWall.src;
  }

  static accessWallIframeId() {
    return window.ENV.accessWall.id;
  }

  // Returns the current URL without the anchor.
  static getUrl() {
    return window.location.href.match(/(^[^#]*)/)[0];
  }
}
